import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import ScrollToTop from '../ScrollToTop';
import { AuthProvider } from '../../context/AuthContext';
import { SpinnerProvider } from '../../context/SpinnerContext';
import GlobalSpinner from '../GlobalSpinner';
import StatusMessageProvider from '../Page/context/StatusMessageContext';
import { AppStatusProvider } from '../../context/AppStatusContext';
import { ModalProvider } from '../../context/ModalContext';
import Router from '../Router';
import IdleTimer from '../IdleTimer';
import { NotificationBadgeProvider } from '../../context/NotificationBadgeContext';
import SpidCieInfoModal from '../SpidCieInfoModal';

import './style/root.css';

export default function Root() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <SpinnerProvider>
        <GlobalSpinner />
        <AppStatusProvider>
          <AuthProvider>
            <NotificationBadgeProvider>
              <IdleTimer />
              <StatusMessageProvider>
                <ModalProvider>
                  <SpidCieInfoModal />
                  <Router />
                </ModalProvider>
              </StatusMessageProvider>
            </NotificationBadgeProvider>
          </AuthProvider>
        </AppStatusProvider>
      </SpinnerProvider>
    </BrowserRouter>
  );
}
